import { render, staticRenderFns } from "./PollForm.vue?vue&type=template&id=1be68d99&"
import script from "./PollForm.vue?vue&type=script&lang=ts&"
export * from "./PollForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports